<template>
  <div class="area-chart-skeleton-loader">
    <apex-chart
      type="area"
      height="350"
      :options="chartOptions"
      :series="chartSeries"
    ></apex-chart>
  </div>
</template>

<script>
import ApexChart from 'vue-apexcharts';
import { random } from 'lodash';

export default {
  name: 'AreaChartSkeletonLoader',

  props: {
    quantitySeries: {
      type: Number,
      required: false,
      default: 3,
    },
  },

  data() {
    return {
      chartSeries: this.generateChartSeries(),
    };
  },

  methods: {
    /**
     * Generate a random chart series.
     *
     * @returns {{data: number[], name: string}[]}
     */
    generateChartSeries() {
      return Array(this.quantitySeries).fill('').map(() => ({
        name: 'Key',
        data: Array(5).fill('').map(() => random(1, 20)),
      }));
    },
  },

  computed: {
    chartOptions() {
      return {
        chart: {
          height: window.screen.availHeight > 768 ? 350 : 300,
          type: 'area',
          toolbar: {
            show: false,
          },
          sparkline: {
            enabled: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'smooth',
          width: 0,
        },
        xaxis: {
          type: 'category',
          categories: [],
          labels: {
            show: false,
          },
          tooltip: {
            enabled: false,
          },
        },
        yaxis: {
          low: 0,
          offsetX: 0,
          offsetY: 0,
          show: false,
          labels: {
            low: 0,
            offsetX: 0,
            show: false,
          },
          axisBorder: {
            low: 0,
            offsetX: 0,
            show: false,
          },
        },
        tooltip: {
          enabled: false,
          x: {
            format: 'dd/MM/yy HH:mm',
          },
        },
        legend: {
          show: false,
        },
        grid: {
          show: false,
        },
        fill: {
          type: 'gradient',
          opacity: [1],
          colors: ['#DDDBDD'],
        },
      };
    },
  },

  mounted() {
    this.intervalGenerateChartSeries = setInterval(() => {
      this.chartSeries = this.generateChartSeries();
    }, 2000);
  },

  beforeDestroy() {
    clearInterval(this.intervalGenerateChartSeries);
  },

  components: {
    ApexChart,
  },
};
</script>

<style lang="scss" scoped>
.area-chart-skeleton-loader {
   &:after {
    @apply absolute;
    @apply top-0;
    @apply right-0;
    @apply bottom-0;
    @apply left-0;
    transform: translateX(-100%);
    background-image: linear-gradient(90deg, rgba(#fff, 0) 0, rgba(#fff, 0.2) 20%, rgba(#fff, 0.5) 60%, rgba(#fff, 0));
    animation: skeleton-loader 3s infinite;
    content: '';
  }
}
</style>
